import React, { useEffect } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PriceInputWithEarnings from '../../../../../../DollarPriceInput/variants/PriceInputWithEarnings';
import useValidation from '../../useValidation';
import yupResolver from '../../../../../../utils/yupResolver';

export const PLACEHOLDER_FOLDER_PRICE = 10;

export interface Props {
  name?: string;
  currentGallection?: any;
  onChange: (price: string) => void;
}

const PriceField: React.FC<Props> = ({
  name = 'price',
  onChange,
  currentGallection,
}) => {
  const { t } = useTranslation();

  const validationSchema = useValidation();
  const formContext = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: {
      price:
        currentGallection?.premiumFolderData?.dollarPrice ??
        PLACEHOLDER_FOLDER_PRICE,
    },
  });

  // Data is submitted on change which makes this a bit ugly
  const { handleSubmit, watch, register, control, errors } = formContext;
  register('price');

  // monitor price value and update Gallection
  const watchPrice = watch('price');

  useEffect(() => {
    handleSubmit(data => {
      if (data.price) {
        onChange(data.price.toString());
      }
    })();
  }, [handleSubmit, onChange, watchPrice]);

  const errorMessage: string | undefined = errors[name]?.message;
  const {
    field: { ref, ...fieldProps },
  } = useController({
    name,
    control,
  });

  return (
    <PriceInputWithEarnings
      {...fieldProps}
      label={t('mediapopup.gallections.a11y.priceInputLabel')}
      error={errorMessage}
      placeholder={PLACEHOLDER_FOLDER_PRICE}
      ref={ref}
      productType="gallery"
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
